import { render, staticRenderFns } from "./AnGenes.vue?vue&type=template&id=689e49c0&"
import script from "./AnGenes.vue?vue&type=script&lang=js&"
export * from "./AnGenes.vue?vue&type=script&lang=js&"
import style0 from "./AnGenes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports